import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Tag,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import iconsdataset from "./data";
import "serpul-icons/fonts/serpul-icon.css";
import { useState } from "react";

const Page = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selected, setSelected] = useState(null);
  const [dataSet, setDataSet] = useState(iconsdataset);
  const toast = useToast();

  const allPanel = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
  ];
  const style = {
    search: {},
    title: {
      fontSize: "18px",
      fontWeight: 700,
      textAlign: "left",
    },
    tag: {
      fontSize: "12px",
      marginLeft: "4px",
      padding: "2px 4px",
      background: "#e5e5e5",
      borderRadius: "4px",
      height: "18px",
    },
    wrapIcon: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      gap: "10px 10px",
    },
    icon: {
      border: "1px solid #d3d3d3",
      width: "100px",
      height: "80px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      lineHeight: "32px",
      fontSize: "32px",
      borderRadius: "4px",
      cursor: "pointer",
      flexDirection: "column",
      textAlign: "center",
      padding: "8px",
    },
    modalBody: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      gap: "10px",
      marginBottom: "20px",
    },
    example: {
      border: "1px solid #d3d3d3",
      borderRadius: "4px",
    },
  };

  const getNewIcon = (e) => {
    const searchTerm = e.target.value;
    const newDataset = iconsdataset
      .map((category) => ({
        name: category.name,
        list: category.list.filter((item) => item.includes(searchTerm)),
      }))
      .filter((category) => category.list.length > 0);
    setDataSet(newDataset);
  };

  const copyToClipboard = async (copyme) => {
    try {
      await navigator.clipboard.writeText(copyme);
      toast({
        title: "Copied",
        status: "success",
      });
    } catch (e) {
      toast({
        title: "Failed to Copy",
        status: "error",
      });
    }
  };

  return (
    <>
      {/* title */}
      <Text
        fontSize={"48px"}
        fontWeight={"bold"}
        textAlign={"center"}
        marginBottom={"20px"}
      >
        Serpul Icon Dataset
      </Text>
      {/* search */}
      <Box
        marginInline={"140px"}
        boxShadow={"rgba(0, 0, 0, 0.1) 0px 4px 12px"}
        marginBottom={"20px"}
        paddingBlock={"4px"}
        borderRadius={"4px"}
      >
        <InputGroup variant={"custom"} style={style.search}>
          <InputLeftElement>
            <i className="sp-search-md"></i>
          </InputLeftElement>
          <Input
            onChange={(e) => getNewIcon(e)}
            placeholder="Search 1173 icons"
          />
        </InputGroup>
      </Box>
      {/* list */}
      <Box paddingInline={"140px"}>
        {dataSet.map((item) => {
          return (
            <Accordion key={item.name} defaultIndex={allPanel} allowMultiple>
              <AccordionItem style={{ borderTop: "none" }}>
                <h2>
                  <AccordionButton>
                    <Box
                      as="span"
                      flex="1"
                      display={"flex"}
                      alignItems={"center"}
                    >
                      <Text style={style.title}>{item.name}</Text>
                      <Tag size={"sm"} style={style.tag}>
                        {item.list.length}
                      </Tag>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel>
                  <div style={style.wrapIcon}>
                    {item.list.map((x) => {
                      return (
                        <Box
                          key={x}
                          style={style.icon}
                          onClick={() => {
                            onOpen();
                            setSelected(x);
                          }}
                        >
                          <i className={"sp-" + x}></i>
                          <Text
                            fontSize={"10px"}
                            lineHeight={"12px"}
                            marginTop={"8px"}
                          >
                            {x}
                          </Text>
                        </Box>
                      );
                    })}
                  </div>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          );
        })}
      </Box>

      {/* modal */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{selected}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div style={style.modalBody}>
              <Box style={style.icon}>
                <i className={"sp-" + selected}></i>
              </Box>
              <InputGroup variant={"custom"} style={style.example}>
                <Input value={"<i class='sp-" + selected + "'></i>"} readOnly />
                <InputRightElement
                  cursor={"pointer"}
                  onClick={() =>
                    copyToClipboard("<i class='sp-" + selected + "'></i>")
                  }
                >
                  <i className="sp-copy-01"></i>
                </InputRightElement>
              </InputGroup>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Page;
